; (function (root, factory) {
    // UMD/AMDWeb module bolierplate: https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('RichEditor', ['Quill'], factory);
    } else {
        // Browser globals
        root.RichEditor = factory(root.Quill);
    }
}(typeof self !== 'undefined' ? self : this, function (Quill) {
        'use strict';

        var themeCSS = 'https://cdn.quilljs.com/1.3.6/quill.snow.css'

        function isCSSLoaded(href) {
            return true && !!document.querySelectorAll('link[href="' + href + '"]').length;
        }

        function loadCSS(href) {
            if (isCSSLoaded(href)) return Promise.resolve(document.querySelector('link[href="' + href + '"]'));

            return new Promise(function (resolve, reject) {
                var tag = document.createElement('link');
                tag.setAttribute('rel', 'stylesheet');
                tag.href = href;
                tag.addEventListener('load', function (event) { resolve(tag) });
                tag.addEventListener('error', function (event) { reject(event) });
                document.querySelector('head').appendChild(tag);
            });
        }

        function replaceInput() {

        }

        var options = {
            theme: 'snow',
            toolbar: '.editortoolbar',
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline'],
                    //['link'],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }]
                ]
            }
        }

        function Editor(container) {
            this.container = container;
            if (!this.container) return;
            this.label = container.querySelector('label');
            this.input = container.querySelector('textarea');
            this.toolbar = container.querySelector('[data-ui-element="toolbar"]');
            this.editor = container.querySelector('[data-ui-element="editor"]');

            if (!this.editor) return;

            this.createQuill = this.createQuill.bind(this);
            this.updateTextarea = this.updateTextarea.bind(this);

            loadCSS(themeCSS).then(this.createQuill).catch(console.warn);

        }

        Editor.prototype = {
            container: null,
            label: null,
            textarea: null,
            toolbar: null,
            quill: null,
            createQuill: function () {
                this.input.style.position = 'absolute';
                this.input.style.left = '-1000000px';
                options.placeholder = this.input.getAttribute('placeholder');
                this.quill = new Quill(this.editor, options);
                this.quill.container.querySelector('.ql-editor').setAttribute('data-original-input', this.input.id);
                this.quill.clipboard.addMatcher(Node.ELEMENT_NODE, function(node, delta) {
                    var ops = []
                    delta.ops.forEach(function (op) {
                        if (op.insert && typeof op.insert === 'string') {
                            ops.push({
                                insert: op.insert
                            })
                        }
                    })
                    delta.ops = ops
                    return delta
                });
                this.quill.on('text-change', this.updateTextarea);
                this.quill.on('editor-change', this.updateTextarea);

            },
            updateTextarea: function (delta, old, source) {

                this.input.value = this.quill.container.querySelector('.ql-editor').innerHTML;

                var evt = new Event('change', { bubbles: true, cancelable: false });
                this.input.dispatchEvent(evt);
            }
        }

        return Editor
}))